import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import TableBox from './tableBox';
import TabTitle from '../../../../components/tabTitle';

class HygnTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        current: this.props.content.current,
    };

    handleMouseOver = index => {
        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { title, tabTits, tableTits, data } = this.props.content;
        const { current } = this.state;

        return (
            <div className={styles.tab}>
                <TabTitle title={title} tabTits={tabTits} current={current} callback={this.handleMouseOver} />
                <TableBox
                    content={{
                        tit: current === 'hyzf' || current === 'gnzf' ? tableTits[0] : tableTits[1],
                        data: data && data[current],
                    }}
                    isOpen={isOpen}
                />
            </div>
        );
    }
}

export default errorBoundary(HygnTable);
